import { QRCodeSVG } from "qrcode.react";

const fmtDate = (d) => {
  if (!d) return "—";
  const [y, m, day] = d.split("-");
  return y && m && day ? `${m}/${day}/${y}` : d;
};

export const LabelSheet = ({ r, slab, forwardRef }) => {
  const dims =
    r.length_in || r.width_in
      ? `${r.length_in || "?"}" x ${r.width_in || "?"}"`
      : slab?.length_in || slab?.width_in
        ? `${slab.length_in || "?"}" x ${slab.width_in || "?"}"`
        : "—";
  const url = `${window.location.origin}/reservation/${r.id}`;

  return (
    <div
      className="label-4x6 print-label"
      ref={forwardRef}
      data-testid="label-sheet"
    >
      <div className="flex items-start justify-between border-b-2 border-black pb-1">
        <div>
          <div
            style={{
              fontSize: "9pt",
              fontWeight: 700,
              letterSpacing: "0.18em",
            }}
          >
            SLAB RESERVATION
          </div>
          <div
            className="font-mono-data"
            style={{ fontSize: "18pt", fontWeight: 700 }}
          >
            {r.tag}
          </div>
        </div>
        <div style={{ textAlign: "right", fontSize: "9pt", fontWeight: 700 }}>
          <div style={{ border: "2px solid #000", padding: "2px 6px" }}>
            {(r.status || "").toUpperCase()}
          </div>
          <div style={{ marginTop: 4 }}>QTY {r.quantity}</div>
        </div>
      </div>

      <div style={{ marginTop: "0.12in", flex: 1 }}>
        {[
          ["Customer", r.customer_name],
          ["Project", r.project_name],
          ["Slab Color", r.slab_color || slab?.slab_color || "—"],
          ["Serial", slab?.serial_number || "—"],
          ["Bundle", slab?.bundle_number || "—"],
        ].map(([k, v]) => (
          <div key={k} style={{ marginBottom: "0.1in" }}>
            <div className="lbl">{k}</div>
            <div className="val">{v}</div>
          </div>
        ))}

        <div style={{ display: "flex", gap: "0.2in", marginBottom: "0.1in" }}>
          <div>
            <div className="lbl">Install Date</div>
            <div className="val font-mono-data">{fmtDate(r.install_date)}</div>
          </div>
          <div>
            <div className="lbl">Dimensions</div>
            <div className="val font-mono-data">{dims}</div>
          </div>
        </div>

        <div style={{ borderTop: "1px solid #000", paddingTop: "0.06in" }}>
          <div className="lbl">Fabrication Notes</div>
          <div
            style={{
              fontSize: "10pt",
              lineHeight: 1.3,
              whiteSpace: "pre-wrap",
            }}
          >
            {r.comments || "—"}
          </div>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "space-between",
          borderTop: "2px solid #000",
          paddingTop: "0.08in",
        }}
      >
        <div style={{ fontSize: "7pt", color: "#333", maxWidth: "2in" }}>
          Scan to open reservation
          <div className="font-mono-data" style={{ fontSize: "7pt" }}>
            {r.id}
          </div>
        </div>
        <QRCodeSVG
          value={url}
          size={92}
          level="M"
          bgColor="#ffffff"
          fgColor="#000000"
        />
      </div>
    </div>
  );
};
